import x from "../../../assets/images/X.png";
import back from "../../../assets/images/back.png";

import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import SubCategory from "../../../Json/SubCategory.json";

import { useLocation, useNavigate } from "react-router-dom";
import { SetSearch } from "../../../features/TopSearches/TopSearchesSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import {
  SetSelectdPage,
  SetSizeFilter,
  SetTopSizeFilter,
  SortProducts,
} from "../../../features/Products/ProductSlice";
import NotificationModal from "../NotificationModal";

function SeacrhMenuWomen({ show, setShow, id, setShowbefore, setShowfirst }) {
  const { i18n, t } = useTranslation();
  const { subtype } = useSelector((store) => store.topsearches);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sq, setsq] = useState("");

  let parametres = new URLSearchParams(useLocation().search);
  const AccWomen = [
    {
      name: "Bag accessories",
    },
    {
      name: "Bracelets",
    },
    {
      name: "Cases",
    },
    {
      name: "Gloves",
    },
    {
      name: "Hair accessories",
    },
    {
      name: "Handkerchief",
    },

    {
      name: "Hats",
    },
    {
      name: "Key holder",
    },
    {
      name: "Phone Accessories",
    },
    {
      name: "Scarves",
    },
    {
      name: "Sunglasses",
    },

    {
      name: "Belts",
    },
  ];

  const ClothesWomen = [
    {
      name: "Coats",
    },

    {
      name: "Dresses",
    },
    {
      name: "Jackets",
    },
    {
      name: "Jeans",
    },
    {
      name: "Jumpsuits",
    },

    {
      name: "Knitwear",
    },
    {
      name: "Leather jackets",
    },

    {
      name: "Shorts",
    },
    {
      name: "Skirts",
    },
    // {
    //     name:'Sets'
    // },

    {
      name: "Suits",
    },
    {
      name: "Tops",
    },
    {
      name: "Trench coats",
    },
    {
      name: "Trousers",
    },
    {
      name: "Pants",
    },
    {
      name: "Swimwear",
    },
  ];

  return (
    <>
      <Modal show={show} fullscreen className="modal fade mx-0 px-0">
        <Modal.Body className="p-0 m-0 ">
          <div className="modal-header justify-content-between align-items-center d-flex pb-0 px-4">
            <div style={{ cursor: "pointer" }} onClick={() => setShow(false)}>
              <button
                type="button"
                className="close close-txt close-modal align-items-center px-0"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShow(false)}
              >
                <img
                  alt="main"
                  src={back}
                  onClick={() => setShow(false)}
                  className={` ${
                    i18n.language == "en" ? "Previous" : "PreviousAr"
                  }`}
                />
              </button>
            </div>
            <button
              type="button"
              className="close close-txt close-modal align-items-center px-0"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => setShow(false)}
            >
              <img
                alt="main"
                src={x}
                onClick={() => setShow(false)}
                className="x-close  mb-1"
              />
            </button>
          </div>

          <div className="modal-body px-4">
            {subtype == "Clothes" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Clothes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Just in")}
                  </div>
                </div>

                {ClothesWomen.map((cloth) =>
                  SubCategory.filter((subcat) => subcat.name == cloth.name)
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                    .map((sub) => (
                      <>
                        <div
                          className="searchmenunew pb-4"
                          onClick={() =>
                            setShow(false) &
                            setShowbefore(false) &
                            setShowfirst(false)
                          }
                        >
                          <div
                            onClick={() =>
                              navigate(
                                `/products?id=yJDeEt0uKPxfxtqOM42V&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                              )
                            }
                            className="searchmenunew "
                          >
                            {i18n.language == "en" ? sub.name : sub.nameAr}
                          </div>
                        </div>
                      </>
                    ))
                )}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=yJDeEt0uKPxfxtqOM42V&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Clothes")}
                  </div>
                </div>
              </>
            )}
            {subtype == "Shoes" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Shoes")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Just in")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) => subcat.idTypeCategory == "WJmwaMSWxtl1dK1sPZ1x"
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <>
                      <div
                        className="searchmenunew pb-4"
                        onClick={() =>
                          setShow(false) &
                          setShowbefore(false) &
                          setShowfirst(false)
                        }
                      >
                        <div
                          onClick={() =>
                            navigate(
                              `/products?id=WJmwaMSWxtl1dK1sPZ1x&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                            )
                          }
                          className="searchmenunew "
                        >
                          {i18n.language == "en" ? sub.name : sub.nameAr}
                        </div>
                      </div>
                    </>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=WJmwaMSWxtl1dK1sPZ1x&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Shoes")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Bags" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Bags")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Just in")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) => subcat.idTypeCategory == "AqFLulu9y2m4mqEIkch1"
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <>
                      <div
                        className="searchmenunew pb-4"
                        onClick={() =>
                          setShow(false) &
                          setShowbefore(false) &
                          setShowfirst(false)
                        }
                      >
                        <div
                          onClick={() =>
                            navigate(
                              `/products?id=AqFLulu9y2m4mqEIkch1&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                            )
                          }
                          className="searchmenunew "
                        >
                          {i18n.language == "en" ? sub.name : sub.nameAr}
                        </div>
                      </div>
                    </>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=AqFLulu9y2m4mqEIkch1&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Bags")}
                  </div>
                </div>
              </>
            )}

            {subtype == "Accessories" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("Accessories")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Just in")}
                  </div>
                </div>

                {AccWomen.map((acc) =>
                  SubCategory.filter(
                    (subcat) =>
                      subcat.name == acc.name &&
                      subcat.idTypeCategory == "LVw0hUP9kEcd1Qr9CoEk"
                  ).map((sub) => (
                    <>
                      <div
                        className="searchmenunew pb-4"
                        onClick={() =>
                          setShow(false) &
                          setShowbefore(false) &
                          setShowfirst(false)
                        }
                      >
                        <div
                          onClick={() =>
                            navigate(
                              `/products?id=LVw0hUP9kEcd1Qr9CoEk&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                            )
                          }
                          className="searchmenunew "
                        >
                          {i18n.language == "en" ? sub.name : sub.nameAr}
                        </div>
                      </div>
                    </>
                  ))
                )}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=LVw0hUP9kEcd1Qr9CoEk&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Accessories")}
                  </div>
                </div>
              </>
            )}

            {subtype == "watchesandJewelry" && (
              <>
                <div
                  className="w-100 pt-2 pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenutitle"
                    style={{ textTransform: "uppercase" }}
                    onClick={() =>
                      navigate(
                        "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj"
                      ) & dispatch(SortProducts("")) &&
                      setShow(false) &
                        setShowbefore(false) &
                        setShowfirst(false)
                    }
                  >
                    {t("watchesandJewelry")}
                  </div>
                </div>
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    onClick={() =>
                      navigate(
                        "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("Newest")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("Just in")}
                  </div>
                </div>

                {SubCategory.filter(
                  (subcat) =>
                    subcat.idTypeCategory == "07kdA6cD3NDKxX8pQ7w1" &&
                    subcat.id != "8aLDyffgJkHZdmFkFwRc"
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <>
                      <div
                        className="searchmenunew pb-4"
                        onClick={() =>
                          setShow(false) &
                          setShowbefore(false) &
                          setShowfirst(false)
                        }
                      >
                        <div
                          onClick={() =>
                            navigate(
                              `/products?id=${sub.idTypeCategory}&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                            )
                          }
                          className="searchmenunew "
                        >
                          {i18n.language == "en" ? sub.name : sub.nameAr}
                        </div>
                      </div>
                    </>
                  ))}
                {SubCategory.filter(
                  (subcat) => subcat.id == "kYTvn5wAxopx5jpqotC0"
                )
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((sub) => (
                    <>
                      <div
                        className="searchmenunew pb-4"
                        onClick={() =>
                          setShow(false) &
                          setShowbefore(false) &
                          setShowfirst(false)
                        }
                      >
                        <div
                          onClick={() =>
                            navigate(
                              `/products?id=${sub.idTypeCategory}&subcategory=${sub.id}&gender=WFA967se7qX0jYtySgTj`
                            )
                          }
                          className="searchmenunew "
                        >
                          {i18n.language == "en" ? sub.name : sub.nameAr}
                        </div>
                      </div>
                    </>
                  ))}
                <div
                  className="w-100  pb-4 px-0 align-items-center d-flex justify-content-between"
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setShow(false) & setShowbefore(false) & setShowfirst(false)
                  }
                >
                  <div
                    className="searchmenunew"
                    style={{ fontFamily: "Montserrat-SemiB" }}
                    onClick={() =>
                      navigate(
                        "/products?id=07kdA6cD3NDKxX8pQ7w1&gender=WFA967se7qX0jYtySgTj"
                      ) &
                      dispatch(SortProducts("")) &
                      setShow(false) &
                      setShowbefore(false) &
                      setShowfirst(false)
                    }
                  >
                    {t("View All Jewelry")}
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SeacrhMenuWomen;
